import { gql } from "@apollo/client";

export const REG_FTD = gql`
query regFtd($pageNo:Int, $pageSize:Int!, $regFtdFilterInput:RegFtdFilterInput!){
    regFtd(pageNo:$pageNo, pageSize: $pageSize, regFtdFilterInput:$regFtdFilterInput){
        count,
        regFtdList{
            userId
            lastBetAmount
            firstBetAmount
            firstDepositAmount
            lastBetDate
            firstBetDate
            firstDepositDate
            registerDate
            userName
            currencyId
        }
    }
}
`

export const GET_REG_FTD_EXPORT = gql`
query RegFtdExport($regFtdFilterInput: RegFtdFilterInput!){
    regFtdExport(regFtdFilterInput: $regFtdFilterInput){
        status,
        csv
    }
}
`;